import {
  fileAccept,
  partitionUploadFiles,
  type UploadExtension,
} from "utils/files/uploadFileTypes";

/**
 * Receipt uploads accept images + PDF only (mirrors the drawer's "JPG, PDF,
 * PNG, WEBP" messaging), a narrower set than every upload type.
 */
const RECEIPT_EXTENSIONS: readonly UploadExtension[] = [
  "pdf",
  "png",
  "jpeg",
  "jpg",
  "webp",
];

/** `accept` attribute for a receipt `<input type="file">`. */
export const RECEIPT_FILE_ACCEPT = fileAccept(RECEIPT_EXTENSIONS);

/**
 * Split an incoming selection into supported files and rejected filenames.
 * Callers surface the rejected names in a toast (mirrors the admin dropzone).
 */
export const partitionReceiptFiles = (files: FileList | File[]) =>
  partitionUploadFiles(files, RECEIPT_EXTENSIONS);
